import * as React from 'react';
import { Config } from '../../helper';

export default function BrokenStep({text = ''}) {
  return (
    <div>
      <p className='p--large'>{Config.I18n.Errors.BrokenStep}</p>
      <p>{text}</p>
    </div>
  );
}
